import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { getOfferDetails } from "./actionCreator";

export const offerDetailsSlice = createSlice({
  name: "offerDetails",
  initialState,
  reducers: {
    setPaginationModel(state, action) {
      console.log("offer action", action);
      state.page = action.payload.page;
      state.limit = action.payload.pageSize;
    },
    resetPaginationModel(state, action) {
      state.page = 0;
      state.limit = 25;
    },
    setOfferId(state, action) {
      state.id = action.payload.id;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOfferDetails.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getOfferDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
      state.total = action.payload?.total;
    });
    builder.addCase(getOfferDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.data = [];
      state.error = action.error.message;
    });
  },
});

export const { setPaginationModel, resetPaginationModel, setOfferId } =
  offerDetailsSlice.actions;
export default offerDetailsSlice.reducer;
